define((require) => {
    "use strict";

    const Marionette               = require("marionette");
    const PublishToolbarView       = require("ui/publish/PublishToolbarView");
    const PublishOptionsProvider   = require("editor/ui/experience/editor/PublishOptionsProvider");
    const FramedPublishToolbarView = require("ui/publish/FramedPublishToolbarView");
    const {Logger}                   = require("shared/util/Logger");
    const LoggedIn                 = require("shared/security/LoggedIn");
    const LoggedInUserState        = require("shared/ui/user/LoggedInUserState");

    const logger = new Logger("PublishController");

    // Note: the PublishView will encode the url (uri) before opening the publish toolbar window using this
    // controller, but the "url" argument here is deduced from a Backbone route! And Backbone decodes uris
    // for routes already, i.e. to ensure the matched part of the uri does not need to be decoded manually
    // every time, so trying to call "decodeUriComponent(url)" here will raise an error in case % is used in the
    // url! If the controller methods are called explicitly, the caller must thus ensure the uri's (urls) have
    // be decoded beforehand...
    return Marionette.Controller.extend({
        // This is run in a separate/window, as an entirely standalone editor, just showing this view - we
        // could (and should) optimise this a lot!
        showToolbarView(url, projectId) {
            const project = projectId ? LoggedInUserState.get("projects").get(projectId) : null;

            PublishOptionsProvider.provide({project, fetchChannelConfig: true, maxScenes: 1})
                .then(({publishableCollection, publishables, channelConfig}) => {
                    // Authentication controller ensures we only load pushed experiences!...
                    const experienceMetadata = LoggedInUserState.get("experienceMetadata");

                    this.options.region.show(new PublishToolbarView({
                        publishables,
                        publishableCollection,
                        channelConfig,
                        url,
                        experienceMetadata,
                        project
                    }));
                })
                .fail(() => {
                    logger.error(`Unable to fetch publish options for company with id: ${LoggedIn.companyId()}`);
                });
        },

        showFramedToolbarView(url, projectId) {
            this.options.region.show(new FramedPublishToolbarView({
                url,
                projectId
            }));
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/publish/PublishController.js